import * as Yup from "yup";

export default Yup.object().shape({
  jobTitle: Yup.string()
    .required("Title is required")
    .min(2, "Title must be at least 2 characters long")
    .max(50, "Title cannot be longer than 50 characters"),

  employmentType: Yup.string().required("Employment Type is required"),

  companyName: Yup.string()
    .required("Company is required")
    .min(2, "Company must be at least 2 characters long")
    .max(50, "Company cannot be longer than 50 characters"),

  location: Yup.string().required("Location is required"),

  startDate: Yup.date()
    .required("Start Date is required")
    .typeError("Invalid date format")
    .test("startDate-before-endDate", "Start Date must be before End Date", function (value) {
      const { endDate } = this.parent;
      if (value && endDate) {
        return new Date(value) < new Date(endDate);
      }
      return true;
    }),

  endDate: Yup.date()
    .nullable()
    .when("currentlyWorkingHere", (currentlyWorkingHere, schema) => {
      return currentlyWorkingHere[0] === false
        ? schema.required("End Date is required").typeError("Invalid date format")
        : schema.nullable();
    })
    .test("endDate-after-startDate", "End Date must be after Start Date", function (value) {
      const { startDate } = this.parent;
      if (value && startDate) {
        return new Date(value) > new Date(startDate);
      }
      return true;
    }),
});
